import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { factory } from 'src/app/config/constants';
import { QuotationFactoryService } from 'src/app/services/quotation-factory.service';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-insurance-type',
  templateUrl: './input-insurance-type.component.html',
  styleUrls: ['./input-insurance-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputInsuranceTypeComponent),
      multi: true
    }
  ]
})
export class InputInsuranceTypeComponent extends FormComponentControl implements OnInit {
  errors = inputMgsErrs.insuranceType;
  @Input() isShowPA = true;
  @Input() isDisabled: boolean;
  isInsurances: boolean;
  isPA: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private quotationFactoryService: QuotationFactoryService,
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.checkQuickQuote();
  }

  checkQuickQuote() {
    /**
     * Checks the quick quote status from the session storage 
     * and updates the state of insurance and personal accident variables 
     * accordingly.
     * If the quick quote is 'QQ', personal accident is set to true, and 
     * insurance is set to false. Otherwise, both are set to false.
     */
    if (sessionStorage.getItem(factory.quickQuote) == 'QQ') {
      this.isInsurances = false;
      this.isPA = true;
    } else {
      this.isInsurances = false;
      this.isPA = false;
    }
  }
}
